import { render, staticRenderFns } from "./Klaviyo.vue?vue&type=template&id=751c4ab4&scoped=true&"
import script from "./Klaviyo.vue?vue&type=script&lang=js&"
export * from "./Klaviyo.vue?vue&type=script&lang=js&"
import style0 from "./Klaviyo.vue?vue&type=style&index=0&id=751c4ab4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751c4ab4",
  null
  
)

export default component.exports